import { Navigate, useRoutes } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { MaintenancePage } from 'components/ErrorsPage/MaintenancePage'

export const useBuildRoutes = () => {

  const { i18n:{language} } = useTranslation()
      
  return [
    {
      path: '/',
      element: <Navigate to={`/${language}/under-maintenance`} replace />
    },
    {
      path: `/${language}/under-maintenance`,
      element: <MaintenancePage />
    },
  ]
}

export const Views = () => useRoutes( useBuildRoutes() )